module.exports = {
	"id": "RO",
	"name": "Romania",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.013124,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.019686,
			"12": 0.006562,
			"13": null,
			"14": 0.006562,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.013124,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.026248,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.019686,
			"27": null,
			"28": 0.013124,
			"29": 0.013124,
			"30": 0.019686,
			"31": 0.03281,
			"32": 0.006562,
			"33": 0.026248,
			"34": 0.052496,
			"35": 0.019686,
			"36": 0.019686,
			"37": 0.039372,
			"38": 0.039372,
			"39": 0.091868,
			"40": 0.045934,
			"41": 0.026248,
			"42": 0.026248,
			"43": 0.190298,
			"44": 0.052496,
			"45": 0.03281,
			"46": 0.06562,
			"47": 0.085306,
			"48": 0.137802,
			"49": 3.602538,
			"50": 0.19686,
			"51": 0.846498,
			"52": 0.52496,
			"53": 26.562976,
			"54": 7.428184,
			"55": 0.072182,
			"56": 0.019686,
			"57": null
		},
		"firefox": {
			"2": 0.026248,
			"3": 0.03281,
			"4": 0.006562,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.013124,
			"13": 0.006562,
			"14": null,
			"15": null,
			"16": 0.013124,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.006562,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.013124,
			"29": 0.006562,
			"30": 0.013124,
			"31": 0.013124,
			"32": 0.006562,
			"33": 0.019686,
			"34": 0.019686,
			"35": 0.019686,
			"36": 0.019686,
			"37": 0.019686,
			"38": 0.072182,
			"39": 0.03281,
			"40": 0.039372,
			"41": 0.026248,
			"42": 0.039372,
			"43": 0.209984,
			"44": 0.052496,
			"45": 0.170612,
			"46": 0.144364,
			"47": 0.800564,
			"48": 0.616828,
			"49": 9.31804,
			"50": 0.118116,
			"51": 0.019686,
			"52": null,
			"3.5": 0.019686,
			"3.6": 0.03281
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.006562,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.006562,
			"29": null,
			"30": 0.006562,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.006562,
			"35": 0.013124,
			"36": 0.223108,
			"37": 0.052496,
			"38": 0.118116,
			"39": 0.052496,
			"40": 1.765178,
			"41": 0.314976,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.118116
		},
		"safari": {
			"0": null,
			"4": 0.013124,
			"5": 0.013124,
			"6": null,
			"7": 0.013124,
			"8": 0.039372,
			"9": 0.045934,
			"10": 0.419968,
			"3.1": null,
			"3.2": null,
			"5.1": 0.026248,
			"6.1": 0.013124,
			"7.1": null,
			"9.1": 0.203422
		},
		"ios_saf": {
			"8": 0,
			"10": 3.37019611324,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0908228855121,
			"8.1-8.4": 0.167791432556,
			"9.0-9.2": 0.0800472889259,
			"9.3": 1.22123427977
		},
		"android": {
			"3": 0,
			"4": 0.0572111627907,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00715139534884,
			"4.1": 0.206368837209,
			"4.2-4.3": 0.515922093023,
			"4.4": 1.18304511628,
			"4.4.3-4.4.4": 1.19326139535
		},
		"ie": {
			"6": 0.0203979710669,
			"7": 0.0271972947559,
			"8": 0.557544542495,
			"9": 0.190381063291,
			"10": 0.183581739602,
			"11": 2.78092338879,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0535831477949,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00148842077208
		},
		"edge": {
			"12": 0.078744,
			"13": 0.314976,
			"14": 0.767754
		},
		"ie_mob": {
			"10": 0.210153802817,
			"11": 0.855626197183
		},
		"bb": {
			"7": 0.020628,
			"10": null
		},
		"samsung": {
			"0": 3.217968
		},
		"and_uc": {
			"0": 0.1719
		},
		"op_mini": {
			"0": 0.721916431433
		},
		"and_chr": {
			"0": 23.485248
		},
		"and_ff": {
			"0": 0.12033
		}
	},
	"total": 97.709452
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/RO.json
 ** module id = 633
 ** module chunks = 0
 **/